import PostCardMenu from './post-card-menu';

export default PostCardMenu;